var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8CoinInHand1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.742 19.1734C26.2414 18.1887 25.038 17.796 24.0527 18.296L18.0754 21.3334H10.6874V23.3334H22.9687L25.864 21.862C26.8494 21.362 27.242 20.158 26.742 19.1734Z",
    fill: "#FC9F35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66671 16H1.33337V28.6667H6.66671V16Z",
    fill: "#FB348C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 17.3334H4.66663V27.3334H6.66663V17.3334Z",
    fill: "#D72573"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.042 19.338L31.0366 19.3287C30.512 18.3894 29.3253 18.0534 28.386 18.578L19.8726 23.3334H12V21.3334H18.6666C19.7713 21.3334 20.6666 20.438 20.6666 19.3334C20.6666 18.2287 19.7713 17.3334 18.6666 17.3334H6.66663V27.3334H20C20.0026 27.3334 20.0053 27.3334 20.008 27.3334C20.39 27.3714 20.7866 27.2967 21.1473 27.0954L30.2906 21.9887C31.23 21.464 31.566 20.2774 31.042 19.338Z",
    fill: "#FFDD64"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.6666C19.3133 14.6666 22 11.98 22 8.66663C22 5.35329 19.3133 2.66663 16 2.66663C12.6867 2.66663 10 5.35329 10 8.66663C10 11.9806 12.686 14.6666 16 14.6666Z",
    fill: "#FC9F35"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 10.6667V5.33337H15.3333V6.66671H14V8.00004H15.3333V10.6667H14V12H18V10.6667H16.6667Z",
    fill: "#FAE56B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 6.66663H15.3334V7.99996H16.6667V6.66663Z",
    fill: "#FFF3B8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8CoinInHand1);
export default __webpack_public_path__ + "static/media/icons8-coin-in-hand-1.f9721b781c58979380b5b8d610079e07.svg";
export { ForwardRef as ReactComponent };